module.exports = __webpack_public_path__ + "img/searchIcon.50e6df26.svg";